<div id="CoordinatePopupComponent" #popupRef>
  <div class="card-body">
    <form class="needs-validation">
      <div class="form-group">
        <!--- coordinates -->
        <div class="row mb-3">
          <div class="col-md-12">
            <div class="input-group input-group-sm">
              <div class="input-group-prepend">
                <span class="input-group-text" translate>WIDGET.GOTO.EASTING</span>
              </div>
              <input
                class="form-control"
                id="x-coordinate-clipboard"
                type="text"
                autocomplete="off"
                readonly
                name="xCoordinate"
                [value]="xCoordinate"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="input-group input-group-sm">
              <div class="input-group-prepend">
                <span class="input-group-text" translate>WIDGET.GOTO.NORTHING</span>
              </div>
              <input
                class="form-control"
                id="y-coodinate-clipboard"
                type="text"
                autocomplete="off"
                readonly
                name="yCoordinate"
                [value]="yCoordinate"
              />
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
